import css from 'styled-jsx/css';

export default css`
  .Spread__description,
  .Spread__title {
    margin-right: 0;
    margin-left: 0;
  }

  .Spread__item {
    margin-bottom: 0.5rem;
  }

  .Spread__items {
    display: flex;
    flex-direction: column;
  }

  @media (min-width: 64rem) {
    .Spread__items {
      width: 100%;
    }
  }

  @media (min-width: 75rem) {
    .Spread__items {
      width: 100%;
    }
  }

  @supports (display: grid) {
    @media (min-width: 64rem) {
    .Spread--textLink {
      grid-template:
        'title'
        'description'
        'items'
        / 100%;
    }

    .Spread__title,
    .Spread__description,
    .Spread__link {
      margin-right: 0;
      margin-left: 0;
    }
  }
`;
